const obj = {
  version: "0.41.2",
};

export default obj;
